import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionProps {
  title: string;
  numeral: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  requiredCount: number;
  completedCount: number;
}
export function Accordion({
  title,
  numeral,
  isOpen,
  onToggle,
  children,
  requiredCount,
  completedCount
}: AccordionProps) {
  const isComplete = requiredCount > 0 && completedCount === requiredCount;
  const isNotStarted = completedCount === 0;
  const leftCount = requiredCount - completedCount;
  return <div className="bg-white overflow-hidden border-b border-slate-200 last:border-b-0" data-id="element-240">
      <button type="button" onClick={onToggle} className="w-full flex items-center justify-between py-3 hover:bg-slate-50 transition-colors focus:outline-none" data-id="element-241">
        <div className="flex items-center space-x-2" data-id="element-242">
          {isOpen ? <ChevronUp className="w-4 h-4 text-slate-600" data-id="element-243" /> : <ChevronDown className="w-4 h-4 text-slate-600" data-id="element-244" />}
          <span className="font-bold text-slate-900 text-[13px]" data-id="element-245">
            {numeral}. {title}
          </span>
        </div>
        <div data-id="element-246">
          {isComplete ? <span className="px-2 py-0.5 text-[11px] font-medium bg-green-50 text-green-700 rounded-full border border-green-100 flex items-center gap-1" data-id="element-247">
              <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-248">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-249" />
              </svg>
              Complete
            </span> : isNotStarted ? <span className="px-2 py-0.5 text-[11px] font-medium bg-slate-100 text-slate-600 rounded-full" data-id="element-250">
              Not started
            </span> : <span className="px-2 py-0.5 text-[11px] font-medium bg-amber-50 text-amber-700 rounded-full border border-amber-100" data-id="element-251">
              {leftCount} left
            </span>}
        </div>
      </button>
      {isOpen && <div className="pb-6 pt-2 pl-6" data-id="element-252">{children}</div>}
    </div>;
}